var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-input-autocomplete", {
    ref: "el",
    attrs: {
      name: "unit",
      fancy: _vm.fancy,
      items: _vm.items,
      label: _vm.label,
      value: _vm.value,
      "has-error": _vm.hasError,
    },
    on: {
      blur: function ($event) {
        return _vm.onBlur()
      },
      focus: function ($event) {
        return _vm.onFocus()
      },
      input: function ($event) {
        return _vm.onInput($event)
      },
      "item-click": function ($event) {
        return _vm.onInput($event)
      },
      keyup: function ($event) {
        return _vm.onKeyup($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }